import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

const BillingNavigation = ({tab}) => {
    let params = useParams();
    return (
        <div className="p-3" style={{ backgroundColor: ' #0a1116', borderRadius: '10px' }}>
            <ul className="nav-billing">
                <Link to={`/my/billing/manager/${params.id_venues}`}><li className={tab === "manager" ? "active" : null}><i className="fa-solid fa-list-check me-3"></i>Subscrições</li></Link>
                <Link to={`/my/billing/transactions/${params.id_venues}`}><li className={tab === "transactions" ? "active" : null}><i className="fa-solid fa-arrow-right-arrow-left me-3"></i>Movimentos</li></Link>
                <Link to={`/my/billing/invoices/${params.id_venues}`}><li className={tab === "invoices" ? "active" : null}><i className="fa-solid fa-file-invoice me-3"></i>Faturas</li></Link>
                <Link to={`/my/billing/faq/${params.id_venues}`}><li className={tab === "faq" ? "active" : null}><i className="fa-solid fa-circle-info me-3"></i>FAQ</li></Link>
            </ul>
        </div>
    )
}


export default BillingNavigation;